<template>
  <div class="loginPage">

    <img src="@/assets/images/login/register.jpg" class="loginBg">

    <div class="block">
      <van-icon name="arrow-left" size="28" color="#fff" @click="onClickLeft" class="backButton" />
      <div class="register-block">
        <div class="field-item">
          <div class="hd"><i class="fa fa-user"></i></div>
          <div class="bd"><van-field placeholder="大陆手机号" v-model="inputText.Phone" /></div>
        </div>
        <div class="field-item">
          <div class="hd"><i class="fa fa-lock"></i></div>
          <div class="bd"><van-field type="password" placeholder="不少于6位" v-model="inputText.Password" /></div>
        </div>
        <div class="field-item">
          <div class="hd"><i class="fa fa-user-circle"></i></div>
          <div class="bd"><van-field type="number" placeholder="邀请人会员ID(可选填)" v-model="inputText.InvitationCode" /></div>
        </div>
        <div class="field-item">
          <div class="hd"><i class="fa fa-key"></i></div>
          <div class="bd"><van-field type="number" v-model="inputText.VerifyCode" placeholder="手机验证码" /></div>
        </div>
        <p class="sendCodeLine">
          <!-- <span class="sendCodeBtn">获取验证码</span> -->
          <van-button
            @click="sendRegisterSmsCode"
            :disabled="disabled"
            slot="button"
            size="small"
            type="info"
            class="sendCodeBtn"
          >{{downText}}</van-button>
        </p>
        <div class="btn-area">
          <van-button round @click="register" class="loginbtn">注册</van-button>
        </div>
        <div class="user-agreement">注册即同意<router-link to="/AgreementPage" class="hlight">用户协议</router-link>和<router-link to="/PrivacyPage" class="hlight">隐私政策</router-link></div>
      </div>
      <van-divider
        :style="{ color: 'rgba(255,255,255,.8)', borderColor: 'rgba(255,255,255,.5)', padding: '0 16px' }"
      >
        其他方式
      </van-divider>
      <div class="other-login">
        <div class="item">
          <img src="@/assets/images/login/qq.png">
        </div>
        <div class="item">
          <img src="@/assets/images/login/sina.png">
        </div>
        <div class="item">
          <img src="@/assets/images/login/weixin.png">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import common from "../../tools/common.js";
  import { Toast } from "vant";
  export default {
    data() {
      return {
        inputText: {
          Phone: "",
          VerifyCode: "",
          InvitationCode:"",
          Password: ""
        },
        downText: "获取验证码",
        second: 60,
        disabled: false
      }
    }, 
    methods :{
      onClickLeft() {
        this.$router.go(-1)
      },
      sendRegisterSmsCode() {
        var that = this;
        if (that.inputText.Phone.length <= 0) {
          Toast("手机号不能为空！");
          return false;
        }
        var myreg = /^[1][0-9]{10}$/;
        if (!myreg.test(that.inputText.Phone)) {
          Toast("请输入正常的手机号");
          return false;
        }
        // Object.assign(that.inputText, {
        //   type: "SendRegisterSmsCode"
        // });
        that.$store
          .dispatch({ type: "SendRegisterSmsCodeVue", Phone: that.inputText.Phone })
          .then(res => {
            if(!(res.Result.IsSuccess)){
              Toast(res.Result.Message);
            }else{
              common.countdowm(that, that.inputText.Phone, that.second);
            }
            // if (res.IsSuccess) {
            //   common.countdowm(that, that.inputText.Phone, that.second);
            //   Toast(res.Message);
            // } else {
            //   Toast(res.Message);
            // }
          }, err => {});
      },
      register(){
        var that = this;
        if (that.inputText.Phone.length <= 0) {
          Toast("手机号不能为空！");
          return false;
        }
        var myreg = /^[1][0-9]{10}$/;
        if (!myreg.test(that.inputText.Phone)) {
          Toast("请输入正常的手机号");
          return false;
        }
        if (that.inputText.VerifyCode == "") {
          Toast("验证码不能为空！");
          return false;
        }
        if (that.inputText.Password == "") {
          Toast("密码不能为空！");
          return false;
        }
        if (that.inputText.Password.length < 6) {
          Toast("密码不能小于6位数！");
          return false;
        }
        Object.assign(this.inputText, {
          type: "Register"
        });
        this.$store.dispatch(this.inputText).then(res => {
          console.log(res);
          // if (res.Code == "200"){
            if (res.error!=null && res.error!='') {
              Toast(res.error_description);
            } else {
              Toast("注册成功！");
              that.$router.replace("/Create");
            }
          // }else{
          //   Toast("注册出错！");
          // }

        });

      }
    },
  }
</script>

<style scoped>
.register-block{
  margin-top: 20%;
}
.sendCodeLine{
  text-align: center;
  margin-top: 6%;
  margin-bottom: 20%;
}
.sendCodeBtn{
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
  font-size: 12px;
  color: #fff;
  border-radius: 40px;
  background-color: rgba(255,255,255,.3);
}
</style>
